import xtend from 'xtend'
import xhr from 'xhr'
import urlJoin from 'url-join'

const EMPTY_API_DATASET = {
    datasets: [{data: []}],
    labels: []
};

export const colors = {
    blue: '#36A2EC',
    red: '#FA6283',
    yellow: '#FFE66D',
    green: '#56FD72',
    lavender: '#F9A4FF'
};

export const formatDonutData = (apiData) => {
    if (!apiData) return EMPTY_API_DATASET;

    var keys = Object.keys(apiData);
    return {
        datasets: [
            {
                data: keys.map(function (k) {
                    return apiData[k];
                }),
                backgroundColor: keys.map(function (k, i) {
                    return colors[Object.keys(colors)[i]];
                })
            }
        ],
        labels: keys
    };
}

//var ANALYTICS_URL = 'https://playerstats.invintus.com'
var ANALYTICS_URL = 'https://playerstats-v2.invintus.com';
var ANALYTICS_NAME = 'KvqPoHG2MH4YsbKpP468XGHHs';
var ANALYTICS_KEY = '7WmdkuQ8o4kL6X6rzCuqahmfT';

export const createRequestFn = ({ clientID }) => {
    // pass a pathname, return a function of (params, cb)
    // convenient way to make xhr fns with a signature of (body, cb)
    return function request (urlPath) {
        return function (body, cb) {
            xhr.post({
                url: urlJoin(ANALYTICS_URL, urlPath),
                headers: {
                    authorization: ANALYTICS_NAME,
                    'wsc-api-key': ANALYTICS_KEY
                },
                body: xtend({ clientID }, body),
                json: true
            }, function (err, res, body) {
                if (err) return cb(err)
                if (('' + res.statusCode)[0] != '2') return cb(new Error(
                    res.statusMessage || res.statusCode))

                var _err
                try {
                    if (body.errors.hasError) {
                        var msg = (typeof body.errors.message === 'string' ?
                            body.errors.message :
                            body.errors.message[0])
                        _err = new Error(msg)
                    }
                } catch(__err) {
                    // ok
                }

                if (_err) return cb(_err)
                cb(null, body)
            })
        }
    }
}
